// eslint-disable-next-line import/prefer-default-export
export function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  }

  if (progress > 100) {
    return 100;
  }

  return progress;
}
//# sourceMappingURL=utils.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/progress/utils.js
// module id = 202
// module chunks = 0